import { openMeldToolsUpdateOperationPhaseSchema, openMeldToolsUpdateRequestSourceSchema } from "../local-components.js";
import * as z$1 from "zod/v4";
//#region src/schemas/daemon/service-update-job.ts
const OPENMELD_DAEMON_SERVICE_UPDATE_JOB_SCHEMA = "openmeld-daemon-service-update-job-v2";
const daemonServiceUpdatePreparedBundleSchema = z$1.strictObject({
	v: z$1.literal(2),
	schema: z$1.literal("openmeld-daemon-active-bundle-v2"),
	bundleId: z$1.string().min(1),
	daemonVersion: z$1.string().min(1),
	entryScriptRelativePath: z$1.string().min(1),
	bundleFormat: z$1.enum([
		"legacy_linked_v1",
		"self_contained_v1",
		"binary_v1"
	]),
	sourceEntryScriptPath: z$1.string().min(1),
	sourcePackageRootPath: z$1.string().min(1),
	sourceDistRootPath: z$1.string().min(1),
	sourceDistFingerprint: z$1.string().min(1).nullable().optional(),
	sourceKind: z$1.enum([
		"workspace",
		"package_install",
		"npx_cache",
		"unknown"
	]),
	createdAt: z$1.iso.datetime({ offset: true }),
	updatedAt: z$1.iso.datetime({ offset: true })
});
const daemonServiceUpdateJobBodySchema = z$1.strictObject({
	attempts: z$1.number().int().nonnegative(),
	desiredState: z$1.enum(["background", "stopped"]),
	errorMessage: z$1.string().min(1).nullable(),
	jobId: z$1.string().min(1),
	preparedBundle: daemonServiceUpdatePreparedBundleSchema,
	requestedAt: z$1.iso.datetime({ offset: true }),
	targetCliVersion: z$1.string().min(1).optional(),
	targetServiceVersion: z$1.string().min(1).optional(),
	targetVersion: z$1.string().min(1),
	updatedAt: z$1.iso.datetime({ offset: true }),
	urgency: z$1.enum(["available", "required"])
});
const daemonServiceUpdateJobV1Schema = daemonServiceUpdateJobBodySchema.extend({
	v: z$1.literal(1),
	schema: z$1.literal("openmeld-daemon-service-update-job-v1"),
	status: z$1.enum([
		"scheduled",
		"running",
		"completed",
		"failed"
	])
});
const daemonServiceUpdateJobSchema = daemonServiceUpdateJobBodySchema.extend({
	v: z$1.literal(2),
	schema: z$1.literal(OPENMELD_DAEMON_SERVICE_UPDATE_JOB_SCHEMA),
	phase: openMeldToolsUpdateOperationPhaseSchema,
	requestSource: openMeldToolsUpdateRequestSourceSchema
});
const storedDaemonServiceUpdateJobSchema = z$1.discriminatedUnion("v", [daemonServiceUpdateJobV1Schema, daemonServiceUpdateJobSchema]);
//#endregion
export { OPENMELD_DAEMON_SERVICE_UPDATE_JOB_SCHEMA, daemonServiceUpdateJobSchema, daemonServiceUpdateJobV1Schema, daemonServiceUpdatePreparedBundleSchema, storedDaemonServiceUpdateJobSchema };

//# sourceMappingURL=service-update-job.js.map